import PropTypes from 'prop-types';

import { styled } from '../../../../stitches.config';

const MOL_CONTAINER_PADDING = 90;

const MolBackground = styled('div', {
  borderRadius: '3px',
  cursor: 'hand',
  position: 'absolute',
  border: '2px dashed #ccc',
});

function MoleculeBackground({ bbox, scale, selected, highlightChanges, ...props }) {
  return (
    <foreignObject
      className="fo-mol-background"
      x={bbox.min[0] - MOL_CONTAINER_PADDING / scale}
      y={bbox.min[1] - MOL_CONTAINER_PADDING / scale}
      width={(bbox.size[0] + MOL_CONTAINER_PADDING * 2) / scale}
      height={(bbox.size[1] + MOL_CONTAINER_PADDING * 2) / scale}
      style={{
        transform: `scale(${scale}, ${scale})`,
        transformOrigin: `${bbox.min[0]}px ${bbox.min[1]}px`,
        overflow: 'visible',
      }}
    >
      <MolBackground
        {...props}
        style={{
          left: MOL_CONTAINER_PADDING / 3 / scale,
          top: MOL_CONTAINER_PADDING / 3 / scale,
          right: MOL_CONTAINER_PADDING / 3 / scale,
          bottom: MOL_CONTAINER_PADDING / 3 / scale,
        }}
      />
    </foreignObject>
  );
}

MoleculeBackground.propTypes = {
  bbox: PropTypes.object,
  scale: PropTypes.number,
  selected: PropTypes.bool,
  recentlyChanged: PropTypes.bool,
};

export default MoleculeBackground;
